<template>
  <footer class="footer">
    <div class="container">
      <div class="qrcode-section">
        <h4>扫码关注</h4>
        <div class="qrcode-grid">
          <div class="qrcode-item" v-for="(qrcode, index) in qrcodes" :key="index">
            <div class="qrcode-image">
              <img :src="require(`@/assets/images/${qrcode.image}`)" :alt="qrcode.name">
            </div>
            <p>{{ qrcode.name }}</p>
          </div>
        </div>
      </div>
      
      <div class="footer-content">
        <div class="footer-section">
          <img src="@/assets/images/logo.png" alt="腾智一体化ERP logo" class="footer-logo">
          <p class="company-desc">腾智科技致力于为制造业企业提供智能化、一体化的ERP解决方案，助力企业数字化转型升级。</p>
        </div>

        <div class="footer-section">
          <h4>快速链接</h4>
          <ul class="footer-links">
            <li><router-link to="/about">关于我们</router-link></li>
            <li><router-link to="/function">产品功能</router-link></li>
            <li><router-link to="/pro">产品中心</router-link></li>
            <li><router-link to="/zskt">知识课堂</router-link></li>
            <li><router-link to="/list">企业动态</router-link></li>
          </ul>
        </div>

        <div class="footer-section">
          <h4>产品服务</h4>
          <ul class="footer-links">
            <li><a href="/pro#production">生产管理系统</a></li>
            <li><a href="/pro#warehouse">仓储物流管理</a></li>
            <li><a href="/pro#supply">供应链协同</a></li>
            <li><a href="/pro#analysis">数据分析平台</a></li>
            <li><router-link to="/contact">技术支持服务</router-link></li>
          </ul>
        </div>

        <div class="footer-section">
          <h4>联系我们</h4>
          <ul class="contact-info">
            <li><i class="fas fa-phone"></i> 4006-696-280</li>
            <li><i class="fas fa-map-marker-alt"></i> 山东省枣庄滕州市人才大厦906室</li>
          </ul>
        </div>
      </div>
      
      <div class="footer-bottom">
        <div class="copyright">
          <p>&copy; 2024 腾智科技 版权所有 | <a href="/about#privacy">隐私政策</a> | <a href="/about#terms">服务条款</a></p>
        </div>
        <div class="certifications">

         <span>
  <i class="fas fa-list"></i>
  &nbsp;
  <a href="https://beian.miit.gov.cn/" target="_blank" style="text-decoration: none; color: inherit;">
    鲁ICP备2025182624号-1
  </a>
</span>
          <span><i class="fas fa-shield-alt"></i> ISO27001认证</span>
          <span><i class="fas fa-award"></i> 高新技术企业</span>
          <span><i class="fas fa-certificate"></i> 软件企业认证</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      qrcodes: [
        { name: '公众号', image: 'gongzhonghao.jpg' },
        { name: '视频号', image: 'shipinhao.jpg' },
        { name: '抖音', image: 'douyin.jpg' },
        { name: '小红书', image: 'xiaohongshu.jpg' }
      ]
    }
  }
}
</script>

<style scoped>
:root {
  --primary-color: #009b7b;
  --secondary-color: #006d56;
  --accent-color: #4cd4bc;
  --white: #ffffff;
}

/* 页脚样式 */
.footer {
  background: #006d56;
  color: var(--white);
  padding: 60px 0 20px;
}

/* 二维码区域样式 */
.qrcode-section {
  text-align: center;
  padding: 20px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 30px;
}

.qrcode-section h4 {
  color: var(--white);
  font-size: 24px;
  margin-bottom: 30px;
  position: relative;
  padding-bottom: 10px;
  text-align: center;
}

.qrcode-section h4::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 2px;
  background: var(--accent-color);
}

.qrcode-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  max-width: 1000px;
  margin: 0 auto;
}

.qrcode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s ease;
}

.qrcode-item:hover {
  transform: translateY(-5px);
}

.qrcode-image {
  width: 150px;
  height: 150px;
  margin-bottom: 15px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 155, 123, 0.15);
  border: 1px solid rgba(0, 155, 123, 0.05);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.qrcode-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.qrcode-item p {
  color: var(--white);
  font-size: 16px;
  margin: 0;
}

/* 页脚内容区域 */
.footer-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin-bottom: 40px;
}

.footer-section {
  padding: 0 15px;
}

.footer-logo {
  max-width: 150px;
  margin-bottom: 20px;
}

.company-desc {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 20px;
  line-height: 1.8;
}

.footer-section h4 {
  color: var(--white);
  font-size: 18px;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}

.footer-section h4::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background: var(--accent-color);
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-links a:hover {
  color: var(--accent-color);
  padding-left: 5px;
}

.contact-info {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-info li {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  color: rgba(255, 255, 255, 0.8);
}

.contact-info li i {
  margin-right: 10px;
  color: var(--accent-color);
}

/* 页脚底部 */
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.copyright {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.copyright p {
  margin: 0;
}

.copyright a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
}

.copyright a:hover {
  color: var(--accent-color);
}

.certifications {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.certifications span {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  display: flex;
  align-items: center;
}

.certifications i {
  margin-right: 5px;
  color: var(--accent-color);
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .footer-content {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .qrcode-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .qrcode-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 0 20px;
  }
  
  .qrcode-image {
    width: 120px;
    height: 120px;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
  }

  .footer-section {
    text-align: center;
    padding: 0;
    margin-bottom: 30px;
  }

  .footer-section h4::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .contact-info li {
    justify-content: center;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  
  .certifications {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 40px 0 20px;
  }
  
  .qrcode-section h4 {
    font-size: 20px;
  }
  
  .footer-section h4 {
    font-size: 16px;
  }
}

.container {
  max-width: 1450px;
  margin: 0 auto;
  padding: 0 15px;
}
</style>